import { render, staticRenderFns } from "./addDwelling.vue?vue&type=template&id=01134c4d&scoped=true&"
import script from "./addDwelling.vue?vue&type=script&lang=js&"
export * from "./addDwelling.vue?vue&type=script&lang=js&"
import style0 from "./addDwelling.vue?vue&type=style&index=0&id=01134c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01134c4d",
  null
  
)

export default component.exports